
import React from 'react';
import { Check } from 'lucide-react';
import { Treatment } from '@/data/treatmentData';

interface EnabledServicesPreviewProps {
  services: Treatment[];
}

const EnabledServicesPreview: React.FC<EnabledServicesPreviewProps> = ({ services }) => {
  if (services.length === 0) {
    return (
      <div className="text-center py-6 text-muted-foreground">
        No services enabled in this category
      </div>
    );
  }
  
  return (
    <div className="space-y-1 border rounded-md p-4 bg-muted/30">
      <h3 className="font-medium mb-3">Services visible to patients:</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {services.map(service => (
          <div key={service.id} className="flex items-start gap-2">
            <Check className="h-4 w-4 text-green-500 mt-1" />
            <div>
              <div className="font-medium text-sm">{service.name}</div>
              <div className="text-sm text-muted-foreground">
                {service.customPrice !== undefined 
                  ? `$${service.customPrice}`
                  : `$${service.defaultPrice}`}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default EnabledServicesPreview;
